/**
 * Created by emma on 16/3/24.
 */
var Cookie = require('util/cookie.js');
import {apiUrl} from 'config';
import ajax from 'util/ajax';

export default {
    isLogined: function () {
        var token = Cookie.get('X-YY-TOKEN');
        return token;
    },
    getInfo: function (key) {
        var json = {
            token: Cookie.get('X-YY-TOKEN')
        };
        return key ? json[key] : json;
    },
    redirectToLogin: function () {
        if (!this.isLogined()) {
            window.location.href = "/login.html?callbackUrl=" + encodeURIComponent(location.href);
            return false;
        }
        return true;
    },
    logout: function () {
        ajax({
            url: apiUrl + '/user/logout',
            type: 'post',
            dataType: "json",
            success: function (result) {
                if (result && result.code == 0) {
                    window.location.href = '/';
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./components/account/login.js